import axios from "axios"
// import { useBasicStore } from "@/store/basic";
import { useRoute, useRouter } from "vue-router"
import { ElMessage, ElMessageBox } from "element-plus"
//这里是axios进行最基本的封装，如果后续需要添加详细的可以根据需求自行添加
//这里是基础地址 直接替换就行baseURL
//nuxt前端处理跨域怎么都不生效，如果要调用服务器上的接口，让后端处理一下跨域

// 环境的切换   根据不同的环境  切换不同的IP
let BaseUrl = "https://kpwwwiend.reflect.today/v1"
if (process.env.NODE_ENV == "development") {
    BaseUrl = "https://kpiend.reflect.today/v1"
    // BaseUrl = "http://172.16.1.39:8890/v1/"
} else if (process.env.NODE_ENV == "debug") {
    BaseUrl = ""
} else if (process.env.NODE_ENV == "production") {
    BaseUrl = "https://kpiend.reflect.today/v1"
}
const Router = useRouter()
// http://52.25.81.116:8080/ai/
// http://api.workingmanual.com/api/
const api = axios.create({
    baseURL: BaseUrl, // 替换成你的API的基本URL
    timeout: 300000, // 设置超时时间为 3000 毫秒（3 秒）
    responseType: "json" //响应数据类型，默认json
})
const resetStateAndToLogin = () => {
    const Process = process.env.NODE_ENV
    let path
    console.log(Process)
    if (Process == "development") {
        path =
            "https://auth.successfulmatch.com/realms/ms/protocol/openid-connect/auth?response_type=code&client_id=kpitool&scope=openid profile roles email&redirect_uri=http://localhost:8080/"
    } else {
        path =
            "https://auth.successfulmatch.com/realms/ms/protocol/openid-connect/auth?response_type=code&client_id=kpitool&scope=openid profile roles email&redirect_uri=http://kpiweb.reflect.today/"
    }

    // const path =
    //   'https://auth.successfulmatch.com/realms/ms/protocol/openid-connect/auth?response_type=code&client_id=knowledge-base&scope=openid%20profile%20roles%20email&redirect_uri=http://kno.reflect.today/'
    // router.push({ path: '/login' })
    window.location.href = path
}
// 这个方法是避免重复请求，根据自己需要打开或者关闭    存储每个请求的取消函数
const cacelRequest = () => {
    const cancelTokens = new Map()
    const cancelToken = axios.CancelToken.source()
    config.cancelToken = cancelToken.token

    // 如果存在相同的请求，则取消之前的请求
    if (cancelTokens.has(config.url)) {
        const cancel = cancelTokens.get(config.url)
        cancel("Request canceled due to repeated action")
    }
    // 存储新请求的取消函数
    cancelTokens.set(config.url, cancelToken.cancel)
}
import { ElLoading } from "element-plus"
let loading
//拦截器，请求前需要做些什么。所有请求头相关的信息都可以在这里写
api.interceptors.request.use((config) => {
    // const token = localStorage.getItem("token");
    // const basicStore = useBasicStore();
    // const token = basicStore.token;
    // debugger;
    // console.log( config.url, "--------------");
    // if (config.url !== "/keyclock/handleAuthorizationCode" || config.url !== "/dept/findALL") {
    //     if (!token) {
    //         basicStore.resetStateAndToLogin();
    //     }
    // }
    // if (basicStore.isSelectDept === "1") {
    //     Router.push("/");
    //     // window.location.reload(); // 强制刷新页面
    // }

    // cacelRequest();   //这个方法是避免重复请求，根据自己需要打开或者关闭    存储每个请求的取消函数
    // 这里可以设置请求头部

    config.headers["x-access-token"] = localStorage.getItem("token")
    // if (
    //     config.url !== "/file/update" &&
    //     config.url !== "/file/findOuter" &&
    //     config.url !== "/file/add" &&
    //     config.url !== "history/detail"
    // ) {
    //     loading = ElLoading.service({
    //         lock: true,
    //         text: "Loading",
    //         background: "rgba(0, 0, 0, 0.7)"
    //     });
    // }
    return config
})
//响应拦截器
api.interceptors.response.use(
    (response) => {
        // debugger;
        // loading && loading.close();
        // 在响应之前做些什么
        if (response.data.code !== "8200") {
            ElMessage({
                type: "error",
                message: response.data.msg
            })
        }
        if (response.data.code === "8401") {
            resetStateAndToLogin()
        }

        return response.data
    },
    (error) => {
        console.log(error)

        // loading && loading.close();
        ElMessage({
            type: "error",
            message: error.msg
        })
        if (error.response?.status) {
            //这里判断错误状态码对应不同的逻辑
            switch (error.response.status) {
                // 401: 没权限
                case 401:
                    console.log(401)
                    resetStateAndToLogin()
                    // const basicStore = useBasicStore();
                    // basicStore.resetStateAndToLogin();
                    break
                // 403 token过期
                case 403:
                    console.log(403)
                    break

                // 404请求不存在
                case 404:
                    console.log(404)
                    break
                // 其他错误，直接抛出错误提示
                default:
                    console.log("其他错误")
            }

            // 处理响应错误
            return Promise.reject(error)
        }
    }
)
//取消拦截器   取消请求的时候调用
// api.interceptors.request.eject(() => {});
// GET请求
export const get = async (url, params) => {
    try {
        const response = await api.get(url, { params })
        return response
    } catch (error) {
        throw error
    }
}

// POST请求
export const post = async (url, data) => {
    try {
        const response = await api.post(url, data)
        return response
    } catch (error) {
        throw error
    }
}

// PUT请求
export const put = async (url, data) => {
    try {
        const response = await api.put(url, data)
        return response.data
    } catch (error) {
        throw error
    }
}

// DELETE请求
export const Delete = async (url) => {
    try {
        const response = await api.delete(url)
        return response.data
    } catch (error) {
        throw error
    }
}
